import axios from 'axios';

const API_KEY = process.env.REACT_APP_FORTNITE_API_KEY;
const BASE_URL = 'https://fortnite-api.com/v2';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: API_KEY,
  },
});

export const getPlayerStats = async (name, timeWindow = 'lifetime') => {
  try {
    const response = await api.get(`/stats/br/v2?name=${encodeURIComponent(name)}&language=fr&timeWindow=${timeWindow}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching player stats:', error);
    throw error;
  }
};

export const getItemShop = async () => {
  try {
    const response = await api.get('/shop?language=fr');
    return response.data;
  } catch (error) {
    console.error('Error fetching item shop:', error);
    throw error;
  }
};

export const getNews = async () => {
  try {
    const response = await api.get('/news?language=fr');
    return response.data;
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

export const getMap = async () => {
  try {
    const response = await axios.get('https://fortnite-api.com/v1/map');
    return response.data;
  } catch (error) {
    console.error('Error fetching map:', error);
    throw error;
  }
};
